import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Euro, Users, CreditCard, Activity } from 'lucide-react'

export const MetricCards = () => {
  const metrics = [
    {
      title: 'Vendas Totais',
      value: '€12.450,00',
      trend: '+12% este mês',
      icon: Euro,
    },
    {
      title: 'Utilizadores Ativos',
      value: '+573',
      trend: '+201 na última hora',
      icon: Users,
    },
    {
      title: 'Receita Mensal',
      value: '€45.231,89',
      trend: '+20.1% este mês',
      icon: CreditCard,
    },
    {
      title: 'Crescimento',
      value: '+19%',
      trend: '+2.4% vs mês passado',
      icon: Activity,
    },
  ]

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
      {metrics.map((metric, index) => (
        <Card key={index} className="shadow-sm border-slate-200/60 bg-white">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-xs font-medium text-slate-500 uppercase tracking-wider">
              {metric.title}
            </CardTitle>
            <metric.icon className="h-4 w-4 text-slate-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-slate-900">
              {metric.value}
            </div>
            <p className="text-xs text-slate-500 mt-1 font-medium">
              {metric.trend}
            </p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
